import React from 'react';
import { Button } from '../ui/button';
import { Heart, UserPlus } from 'lucide-react';

const getPersonalizedMessage = (guestProfile) => {
  if (!guestProfile?.answers) return { text: null, link: null };
  const answers = guestProfile.answers;
  if (answers.has_pets === 'Yes, I have pets') {
    const petTypes = answers.pet_types;
    return petTypes
      ? { text: `Looking for ${petTypes.toLowerCase()} communities?`, link: '/clubs' }
      : { text: 'Looking for pet communities near you?', link: '/clubs' };
  }
  if (answers.has_pets === "No, but I'm thinking about it") {
    return { text: 'Still thinking about getting a pet?', link: null };
  }
  if (answers.dream_pet) {
    return { text: `Still dreaming of that ${answers.dream_pet}?`, link: null };
  }
  if (answers.club_benefits) {
    return { text: 'Ready to connect with fellow pet lovers?', link: '/clubs' };
  }
  return { text: "Welcome back! We've missed you.", link: null };
};

/**
 * Panel shown to a recognized returning guest.
 */
export default function WelcomeBackPanel({
  visitCount,
  guestProfile,
  navigate,
  onContinueQuestions,
}) {
  const message = getPersonalizedMessage(guestProfile);

  return (
    <div className="text-center py-2">
      <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-amber-100 flex items-center justify-center">
        <Heart className="w-6 h-6 text-amber-600" />
      </div>
      <h4 className="font-medium mb-1">
        {visitCount > 2 ? `Visit #${visitCount}!` : 'Nice to see you again!'}
      </h4>
      {message.link ? (
        <button
          onClick={() => navigate(message.link)}
          className="text-sm text-primary hover:underline mb-3 block mx-auto"
          data-testid="communities-link"
        >
          {message.text}
        </button>
      ) : (
        <p className="text-sm text-muted-foreground mb-3">{message.text}</p>
      )}

      <div className="space-y-2">
        <Button
          size="sm"
          className="w-full"
          onClick={() => navigate('/register')}
          data-testid="join-free-btn"
        >
          <UserPlus className="w-4 h-4 mr-2" />
          Join Free
        </Button>
        <p className="text-xs text-muted-foreground">Create posts, add pets & more</p>
        <button
          onClick={onContinueQuestions}
          className="text-xs text-primary hover:underline"
        >
          Continue answering questions
        </button>
      </div>
    </div>
  );
}
